export enum UserRole {
  Doctor = 'D',
  SuperDoctor = 'SD',
  MedicalOperator = 'MO',
  DemoAccount = 'DEMO',
}
